import { GET_ALL_STAFF, GET_STAFF_DETAILS } from "./actions";

const initialState = {
  staffList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  getStaffData: {},
  loading: true,
};

const staffReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_STAFF:
      return {
        ...state,
        staffList: payload,
        loading: false,
      };
    case GET_STAFF_DETAILS:
      return {
        ...state,
        getStaffData: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default staffReducer;
